export default {
  storyboardScreens: [
    {
      imageFile: "03_Store_1Persona.jpg",
      title: "Perfect Store Experience",
      text:
        "Click NEXT to learn how brand managers and sales reps deliver a perfect store experience every time.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "ST03-1",
      hasNext: true,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "03_Store_2Scene.jpg",
      title: "Perfect Store Execution",
      text:
        "Lucia+Daniel’s Sales Operation Manager creates a task list ahead of Tom's store visit so he can clearly see his objectives for the day and the score from the last audit.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "ST03-2",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "03a_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "Lucia+Daniel’s Sales Operation Manager creates a task list ahead of Tom's store visit so he can clearly see his objectives for the day and the score from the last audit.",
      coordinates: { left: "17", top: "142", right: "684", bottom: "442" },
      screenId: "ST03a",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "03c_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "After Tom verifies the sign placement, the task score turns green. Objective two is checking the jewellery display. ",
      coordinates: { left: "350", top: "142", right: "349", bottom: "442" },
      screenId: "ST03c",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "03e_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "Tom verifies the number of slots in the display unit and he checks whether jewellery stocks are in place.",
      coordinates: { left: "686", top: "142", right: "14", bottom: "441" },
      screenId: "ST03e",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "03g_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "Next, he makes sure the mannequin is wearing the most popular dresses from the fall collection based on customer preferences.",
      coordinates: { left: "943", top: "84", right: "17", bottom: "539" },
      screenId: "ST03g",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "03j_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "Tom follows the location marker to the cash counter to check for the second Fall Promotion banner. Check. Next he checks to see if popular cocktail dresses are on display. He clicks on the survey…",
      coordinates: { left: "708", top: "508", right: "98", bottom: "111" },
      screenId: "ST03j",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "03k_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "…and checks which dresses are on display and in stock, making sure all marked prices are correct.",
      coordinates: { left: "814", top: "622", right: "152", bottom: "3" },
      screenId: "ST03k",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "03l_Store_651.jpg",
      title: "Perfect Store Execution",
      text:
        "Once Tom's tasks are complete and submitted, he can see his perfect score and view KPIs that comprise the score: stock, display and pricing compliance.",
      coordinates: { left: "960", top: "618", right: "1", bottom: "0" },
      screenId: "ST03l",
      hasNext: false,
      highlightPosition: "Top-Right"
    }
  ]
};
